module.exports = new __parcel__URL__("report-time-tracking.32d7b653.svg").toString();